<template>
  <div class="d-inline">
    <button class="btn btn-outline-primary form-button" @click="showModal">
      {{ $t('contracts.copy_contract.copy') }}
    </button>
    <base-modal v-if="modalVisible" hide-header hide-footer hide-header-close>
      <div class="col-12 nopads">
        <h2 class="editor-header">{{ $t('common.are_you_sure') }}</h2>
        {{ $t('contracts.copy_contract.are_you_sure', { name: contract.name }) }}
            <span class="item-title">
              {{ $t('contracts.copy_contract.copy_orders') }}
            </span>
            <div class="form-check form-switch">
              <input
                  class="form-check-input"
                  type="checkbox"
                  id="copyOrders"
                  name="copy-orders"
                  :checked="copyOrders"
                  @change="copyOrders = $event.target.checked"
              />
            </div>
            <span class="item-title">
              {{ $t('contracts.copy_contract.copy_attachments') }}
            </span>
            <div class="form-check form-switch">
              <input
                  class="form-check-input"
                  type="checkbox"
                  id="copyAttachments"
                  name="copy-attachments"
                  :checked="copyAttachments"
                  @change="copyAttachments = $event.target.checked"
              />
            </div>
      </div>
      <div class="col-12 button-container">
        <button class="btn btn-secondary form-button" @click="closeModal">
          {{ $t('common.cancel') }}
        </button>
        <button class="btn btn-success form-button" :disabled="isLoading" @click="submit">
            {{ !isLoading ? $t('common.yes') : $t('common.loading') }}
        </button>
      </div>
    </base-modal>
  </div>
</template>
<script>
import {restApi} from '../mixins/RestApiMixin'
import BaseModal from "@/components/BaseModal";
import {inject} from "vue";

export default {
  name: 'ContractCopy',
    components: {BaseModal},
    mixins: [restApi],
  props: {
    contract: {
      type: Object,
      default: null
    },
    buttonVariant: {
      type: String,
      default: 'primary'
    },
    setDefaultValues: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      isLoading: false,
      copyOrders: true,
      copyAttachments: false,
      modalVisible: false
    }
  },
  setup() {
    // Inject parents alerter
    const showAlert = inject('showAlert');
    return { showAlert };
  },
  methods: {
    showModal() {
      this.modalVisible = true
    },
    closeModal() {
        this.modalVisible = false
    },
    success(data) {
      this.closeModal()
      this.showAlert(this.$t('contracts.copy_contract.success', { name: data.name }), 'success')
      this.$emit('contract-copied', data)
      this.isLoading = false
    },
    fail() {
      this.closeModal()
      this.showAlert(this.$t('contracts.copy_contract.error'), 'danger')
      this.isLoading = false
    },
    submit() {
      if (this.contract === null) {
        return
      }
      this.isLoading = true
      this.restAdd(this.copyContractUrl(this.contract.id), {
          copy_orders: this.copyOrders,
          copy_attachments: this.copyAttachments
        }, this.success, this.fail)
    },
  },
}
</script>
<style lang="scss" scoped>
.actions-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #e9ecef;
    padding: 1rem .25rem;

    &:last-child {
      border-bottom: 1px solid #e9ecef;
    }
  }
}
</style>
